module.exports = __webpack_public_path__ + "static/media/Dobro - map icons_Kooperacija i partneri icon (1).9a6b6ce6.svg";